module.exports = __webpack_public_path__ + "static/media/login-bg.c04aa462.jpg";